export default "/assets/images/column-image5.133805adab970691.png";